import React from "react";
import { formatPrice } from "../../../../../utilities/formatPrice";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const KPICard = ({
  title,
  value,
  subtitle,
  icon,
  status,
  currency = "€",
  valueLabel,
  customBgColor,
  customTextColor,
  customSubtitleColor,
  customerPurchases = false,
}) => {
  return (
    <div
      className="card border-round-md border-none flex flex-column justify-content-between"
      style={{
        minHeight: "164px",
        boxShadow:
          "0 6px 32px 0 var(--theme-border, #00000008), 0 2px 4px 0 var(--theme-background, #EBEBEB)",
        backgroundColor: customBgColor || "#FFFFFF",
      }}
    >
      <div className="flex align-items-center justify-content-between mb-3">
        <div className="flex align-items-center gap-2">
          {icon && (
            <i className={`${icon} text-xl`} style={{ color: customTextColor || "#26235E" }}></i>
          )}
          <div
            className="m-0 text-xs font-bold"
            style={{ color: customSubtitleColor || "#26235E" }}
          >
            {title}
          </div>
        </div>
        {status && (
          <div>
            <span
              className="px-3 py-1 border-round text-xs font-medium"
              style={{
                backgroundColor:
                  status === "Pendente"
                    ? "#FFF3EB"
                    : customBgColor || "var(--theme-primary, #1DAF61)",
                color: status === "Pendente" ? "#FA7319" : customTextColor || "white",
              }}
            >
              {status}
            </span>
          </div>
        )}
      </div>

      <div>
        <div className="mb-2">
          <span className="text-4xl font-bold" style={{ color: customTextColor || "#091E42" }}>
            {valueLabel != null ? `${value} ${valueLabel}` : `${currency} ${formatPrice(value)}`}
          </span>
        </div>
        {subtitle &&
          (customerPurchases ? (
            <Link
              to="/dashboard-purchases"
              className="text-sm text-decoration-none"
              style={{ color: customSubtitleColor || "var(--theme-text-muted, #344563)" }}
            >
              {subtitle}
            </Link>
          ) : (
            <div
              className="text-sm"
              style={{ color: customSubtitleColor || "var(--theme-text-muted, #344563)" }}
            >
              {subtitle}
            </div>
          ))}
      </div>
    </div>
  );
};

export default React.memo(KPICard);
